import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import userApi from '../../api/userApi'
import {io} from 'socket.io-client'

export const updateProfile = createAsyncThunk('user/updateProfile', async (params, ThunkAPI) => {
    const res = await userApi.updateProfile(params)

    return res.user
})

export const loadMoreComments = createAsyncThunk('user/loadMoreComments', async (params, ThunkAPI) => {
    const res = await userApi.getUserComments(params)

    return res.comments
})

export const getUserComments = createAsyncThunk('user/getUserComments', async (params, ThunkAPI) => {
    const res = await userApi.getUserComments(params)

    return res.comments
})

export const getNewsSaved = createAsyncThunk('user/getNewsSaved', async (params, ThunkAPI) => {
    const res = await userApi.getNewsSaved(params)

    return res.newsSaved
})

export const loadMoreNewsSaved = createAsyncThunk('user/loadMoreNewsSaved', async (params, ThunkAPI) => {
    const res = await userApi.getNewsSaved(params)

    return res.newsSaved
})

export const removeNews = createAsyncThunk('user/removeNews', async (params, ThunkAPI) => {
    const res = await userApi.removeNews(params)

    return res.id
})

export const saveNews = createAsyncThunk('user/saveNews', async (params, ThunkAPI) => {
    const res = await userApi.saveNews(params)

    return res.id
})

export const register = createAsyncThunk('user/register', async (params, ThunkAPI) => {
    const res = await userApi.register(params)

    return res
})

export const login = createAsyncThunk('user/login', async (params, {dispatch}) => {
    const res = await userApi.login(params)
    if(res && res.accessToken) localStorage.setItem('accessToken', res.accessToken)
    
    await dispatch(loadUser())
    
    return res
})

export const loadUser = createAsyncThunk('user/loadUser', async (params, ThunkAPI) => {
    const res = await userApi.loadUser()

    return res
})

export const socialLogin = createAsyncThunk('user/socialLogin', async (params, {dispatch}) => {
    localStorage.setItem('accessToken', params)
    
    await dispatch(loadUser())
    
    return null
})

export const logout = createAsyncThunk('user/logout', async (params, ThunkAPI) => {
    const res = await userApi.logout();

    if(res.success) localStorage.removeItem('accessToken')

    return res
})

const userSlice = createSlice({
    name: 'user',
    initialState: {
        isAuthenticated: false,
        isLoading: true,
        user: {},
        comments: [],
        newsSaved: [],
        socket: io(process.env.REACT_APP_BASE_URL_SERVER)
    },
    reducers: {
        
    },
    extraReducers: {
        [login.pending]: state => {
            state.isLoading = true
        },
        [login.rejected]: state => {
            state.isLoading = false
        },
        [login.fulfilled]: state => {
            state.isLoading = false
        },
        //load user
        [loadUser.pending]: state => {
            state.isLoading = true
        },
        [loadUser.rejected]: state => {
            state.isLoading = false
            state.isAuthenticated = false
            state.user = {}
        },
        [loadUser.fulfilled]: (state, action) => {
            state.isLoading = false
            state.user = action.payload.user
            state.isAuthenticated = true
            state.socket = state.socket.connect()
        },
        //logout
        [logout.rejected]: (state, action) => {
            state.isLoading = false
            state.user = {}
            state.isAuthenticated = false
            state.socialLogin = false
            state.socket = state.socket.close()
            state.comments = {}
        },
        [logout.fulfilled]: (state, action) => {
            state.isLoading = false
            state.user = {}
            state.isAuthenticated = false
            state.socialLogin = false
            state.socket = state.socket.close()
            state.comments = {}
        },
        //save news
        [saveNews.fulfilled]: (state, action) => {
            state.user.newsSaved = [action.payload, ...state.user.newsSaved]
        },
        //remove news
        [removeNews.fulfilled] : (state, action) => {
            state.user.newsSaved = state.user.newsSaved.filter(saved => saved !== action.payload)
        },
        //get news saved
        [getNewsSaved.fulfilled]: (state, action) => {
            state.newsSaved = action.payload
        },
        //load more news saved
        [loadMoreNewsSaved.fulfilled]: (state, action) => {
            state.newsSaved = [...state.newsSaved, ...action.payload]
        },
        //comments
        [getUserComments.fulfilled] : (state, action) => {
            state.comments = action.payload
        },
        //load more
        [loadMoreComments.fulfilled]: (state, action) => {
            state.comments.data = [...state.comments.data, ...action.payload.data]
        },
        //update user
        [updateProfile.fulfilled]: (state, action) => {
            state.user = action.payload
        },
        
    }
});

const { reducer } = userSlice

export default reducer